import React from 'react';

const bone = 'skeleton-sheen rounded-[8px]';

function ChartShape() {
  return (
    <div
      className="flex h-full min-h-[280px] w-full flex-col gap-3 lg:gap-4 p-4"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className={`${bone} h-6 w-48`} />
      <div className={`${bone} min-h-[280px] w-full flex-1`} />
    </div>
  );
}

function HeroShape() {
  return (
    <div
      className="grid min-h-[138px] w-full grid-cols-1 sm:grid-cols-4"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className={`${bone} min-h-[138px]`} />
      <div className={`${bone} min-h-[138px]`} />
      <div className={`${bone} min-h-[138px]`} />
      <div className={`${bone} min-h-[138px]`} />
    </div>
  );
}

function UsageShape() {
  return (
    <div
      className="flex w-full flex-col gap-6 p-4 md:px-8 md:pt-6"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-2">
          <div className={`${bone} h-6 w-36`} />
          <div className={`${bone} h-4 w-56`} />
        </div>
        <div className={`${bone} h-9 w-40`} />
      </div>
      <div className="flex flex-col gap-6 rounded-[12px] border border-[#E8EBE9] bg-white p-6 dark:border-[#30363d] dark:bg-[#1d1d1d]">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-6">
            <div className={`${bone} h-5 w-36 shrink-0`} />
            <div className={`${bone} h-2 w-full flex-1 rounded-full`} />
          </div>
        ))}
      </div>
      <div className={`${bone} h-16 w-full`} />
    </div>
  );
}

function PlansShape() {
  return (
    <div
      className="flex w-full flex-col gap-6 p-4 md:px-8 md:pt-6"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className={`${bone} mx-auto h-7 w-64`} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className={`${bone} min-h-[420px] w-full`} />
        <div className={`${bone} min-h-[420px] w-full`} />
        <div className={`${bone} min-h-[420px] w-full`} />
      </div>
      <div className={`${bone} h-28 w-full`} />
    </div>
  );
}

function FormShape() {
  return (
    <div
      className="flex w-full flex-col gap-5 p-4 md:p-8"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="flex flex-col gap-2">
          <div className={`${bone} h-3 w-24`} />
          <div className={`${bone} h-10 w-full max-w-xl`} />
        </div>
      ))}
    </div>
  );
}

function MapShape() {
  return (
    <div
      className="flex h-full min-h-[420px] w-full flex-col gap-3 p-4 lg:p-8"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="flex gap-2">
        <div className={`${bone} h-10 w-40`} />
        <div className={`${bone} h-10 w-28`} />
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className={`${bone} h-[55px]`} />
        <div className={`${bone} h-[55px]`} />
        <div className={`${bone} h-[55px]`} />
      </div>
      <div className={`${bone} min-h-[320px] w-full flex-1`} />
    </div>
  );
}

function AlertsShape() {
  return (
    <div
      className="flex w-full flex-col gap-4 p-4 md:px-8 md:pt-6"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className={`${bone} h-20 w-full`} />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <div className={`${bone} min-h-[96px]`} />
        <div className={`${bone} min-h-[96px]`} />
        <div className={`${bone} min-h-[96px]`} />
        <div className={`${bone} min-h-[96px]`} />
      </div>
      <div className="flex flex-col gap-2">
        <div className={`${bone} h-16 w-full`} />
        <div className={`${bone} h-16 w-full`} />
        <div className={`${bone} h-16 w-full`} />
        <div className={`${bone} h-16 w-full`} />
      </div>
    </div>
  );
}

function ChatShape() {
  return (
    <div
      className="mx-auto flex min-h-screen w-full max-w-4xl flex-col items-center justify-center py-8"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className={`${bone} h-8 w-56 sm:h-10 sm:w-[280px] md:h-12 md:w-[336px]`} />
      <div className={`${bone} mt-6 h-8 w-64`} />
      <div className={`${bone} mt-10 h-[52px] w-full !rounded-full`} />
    </div>
  );
}

function PageShape() {
  return (
    <div
      className="flex w-full flex-col gap-4 p-4 md:p-8"
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className={`${bone} h-10 w-48`} />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div className={`${bone} h-20`} />
        <div className={`${bone} h-20`} />
        <div className={`${bone} h-20`} />
      </div>
      <div className={`${bone} min-h-[280px] flex-1`} />
    </div>
  );
}

export default function PageSkeleton({ variant = 'inset', shape = 'page' }) {
  const body =
    shape === 'chart' ? <ChartShape /> :
    shape === 'hero' ? <HeroShape /> :
    shape === 'form' ? <FormShape /> :
    shape === 'map' ? <MapShape /> :
    shape === 'chat' ? <ChatShape /> :
    shape === 'alerts' ? <AlertsShape /> :
    shape === 'usage' ? <UsageShape /> :
    shape === 'plans' ? <PlansShape /> :
    <PageShape />;

  if (variant === 'full') {
    return <div className="min-h-screen bg-[#F0F5F2] bg-dark-app">{body}</div>;
  }
  return body;
}
